(function () {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function injectBanner(drawer) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Remove any existing banner first
        var existing = drawer.querySelector('.cart-discount-banner');
        if (existing) existing.remove();

        var discounts = cart.cart_level_discount_applications || [];
        if (discounts.length === 0) return;

        var total = discounts.reduce(function (sum, d) {
          return sum + d.total_allocated_amount;
        }, 0);
        var names = discounts.map(function (d) { return d.title; }).join(', ');

        var banner = document.createElement('div');
        banner.className = 'cart-discount-banner';
        banner.innerHTML = '🎉 <strong>' + names + '</strong> applied — you\'re saving <strong>' + formatMoney(total) + '</strong>';

        var content = drawer.querySelector('.cart-drawer__content');
        if (content) content.prepend(banner);
      });
  }

  function scheduleInject(drawer) {
    clearTimeout(drawer._bannerTimer);
    drawer._bannerTimer = setTimeout(function () {
      var dialog = drawer.querySelector('dialog[open]');
      if (dialog) injectBanner(drawer);
    }, 200);
  }

  function init() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;

    // Watch for dialog open AND any DOM re-renders inside the drawer
    var observer = new MutationObserver(function () {
      scheduleInject(drawer);
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['open'],
      childList: true,
      subtree: true
    });

    // Also re-inject after cart events (with delay for re-render to finish)
    document.addEventListener('cart:refresh', function () {
      setTimeout(function () { injectBanner(drawer); }, 400);
    });
    document.addEventListener('cart:updated', function () {
      setTimeout(function () { injectBanner(drawer); }, 400);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();